<template>
  <v-banner v-if="showBanner" sticky style="z-index: 9999" bg-color="error">
    <template #prepend>
      <v-icon class="mt-4"> mdi-alert-circle-outline </v-icon>
    </template>
    <template #default>
      <div>
        <p>
          {{ t("components.churnedCustomerBanner.message") }}
          <a href="mailto:help@yetipay.me">help@yetipay.me</a>
        </p>
        <br />
        <p>{{ t("components.churnedCustomerBanner.returnDevices") }}</p>
        <a
          :href="returnDevicesLink"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary text-decoration-none"
          >{{ returnDevicesLink }}</a
        >
        <p class="text-caption text-grey">
          {{ t("components.churnedCustomerBanner.warning") }}
        </p>
      </div>
    </template>
  </v-banner>
  <div v-else />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useMerchantsStore } from "@/store/merchants";

const merchantsStore = useMerchantsStore();
const showBanner = computed(
  () =>
    merchantsStore.currentMerchant &&
    merchantsStore.hasMerchantChurned(merchantsStore.currentMerchant),
);
const { t } = useI18n();

const returnDevicesLink = "https://www.royalmail.com/track-my-return#/details/5864";
</script>
